import { Button, Select, Space } from '@bringg/react-components';
import { useTranslation } from 'react-i18next';

export const Pagination = ({
	limit,
	page,
	loading,
	nextPage,
	onChange,
	onSelect
}: {
	limit: number;
	page: number;
	loading: boolean;
	nextPage: boolean;
	onChange: (e: any) => void;
	onSelect: (e: any) => void;
}) => {
	const { t } = useTranslation();

	return (
		<Space style={{ display: 'flex', justifyContent: 'end' }}>
			<Select
				value={limit}
				options={[
					{ id: 25, name: t('PAGINATION.ITEMS_PER_PAGE', { size: 25 }) },
					{ id: 50, name: t('PAGINATION.ITEMS_PER_PAGE', { size: 50 }) },
					{ id: 100, name: t('PAGINATION.ITEMS_PER_PAGE', { size: 100 }) }
				]}
				onSelect={onSelect}
			/>
			<Button
				disabled={loading || page === 1}
				onClick={() => {
					if (page > 1) onChange((p: number) => p - 1);
				}}
			>
				{t('PAGINATION.PREVIOUS')}
			</Button>
			<Button disabled={loading || nextPage} onClick={() => onChange((p: number) => p + 1)}>
				{t('PAGINATION.NEXT')}
			</Button>
		</Space>
	);
};

export default Pagination;
